import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { fetchAuthConfig } from "./api/queries.js";
import { AuthProvider } from "./auth/provider.js";
import { App } from "./App.js";
import "./theme/fonts.js";
import "./theme/tokens.css";
import "./theme/shell.css";
import "./theme/screens.css";

const mode = import.meta.env["VITE_AUTH_MODE"] === "mock" ? "mock" : "oidc";

async function start() {
  if (import.meta.env["VITE_USE_MOCKS"] === "true") {
    const { worker } = await import("./mocks/browser.js");
    await worker.start({ onUnhandledRequest: "bypass", quiet: true });
  }
  const config = await fetchAuthConfig();
  const queryClient = new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false } },
  });
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider config={config} mode={mode}>
          <App config={config} />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
